// Portuguese (ptPT) language pack - Excel-compatible function names
// Maps English function keys to Portuguese localized names (matching Excel PT)

export const ptPT = {
    errors: {
        CYCLE: '#CYCLE!',
        DIV_BY_ZERO: '#DIV/0!',
        ERROR: '#ERROR!',
        NA: '#N/D',
        NAME: '#NOME?',
        NUM: '#NÚM!',
        REF: '#REF!',
        SPILL: '#TRANSPOSIÇÃO!',
        VALUE: '#VALOR!'
    },
    functions: {
        FILTER: 'FILTRAR',
        ADDRESS: 'ENDEREÇO',
        ARRAY_CONSTRAIN: 'ARRAY_CONSTRAIN',
        ARRAYFORMULA: 'ARRAYFORMULA',
        ABS: 'ABS',
        ACOS: 'ACOS',
        ACOSH: 'ACOSH',
        ACOT: 'ACOT',
        ACOTH: 'ACOTH',
        AND: 'E',
        ASIN: 'ASEN',
        ASINH: 'ASENH',
        ATAN2: 'ATAN2',
        ATAN: 'ATAN',
        ATANH: 'ATANH',
        AVERAGE: 'MÉDIA',
        AVERAGEA: 'MÉDIAA',
        AVERAGEIF: 'MÉDIA.SE',
        BASE: 'BASE',
        BIN2DEC: 'BINADEC',
        BIN2HEX: 'BINAHEX',
        BIN2OCT: 'BINAOCT',
        BITAND: 'BIT.E',
        BITLSHIFT: 'BITDESL.ESQ',
        BITOR: 'BIT.OU',
        BITRSHIFT: 'BITDESL.DIR',
        BITXOR: 'BIT.XOU',
        CEILING: 'ARRED.EXCESSO',
        CHAR: 'CARÁCT',
        CHOOSE: 'SELECCIONAR',
        CLEAN: 'LIMPARB',
        CODE: 'CÓDIGO',
        COLUMN: 'COL',
        COLUMNS: 'COLS',
        CONCATENATE: 'CONCATENAR',
        CORREL: 'CORREL',
        COS: 'COS',
        COSH: 'COSH',
        COT: 'COT',
        COTH: 'COTH',
        COUNT: 'CONTAR',
        COUNTA: 'CONTAR.VAL',
        COUNTBLANK: 'CONTAR.VAZIO',
        COUNTIF: 'CONTAR.SE',
        COUNTIFS: 'CONTAR.SE.S',
        COUNTUNIQUE: 'COUNTUNIQUE',
        CSC: 'CSC',
        CSCH: 'CSCH',
        CUMIPMT: 'PGTOJURACUM',
        CUMPRINC: 'PGTOCAPACUM',
        DATE: 'DATA',
        DATEDIF: 'DATADIF',
        DATEVALUE: 'DATA.VALOR',
        DAY: 'DIA',
        DAYS360: 'DIAS360',
        DAYS: 'DIAS',
        DB: 'BD',
        DDB: 'BDD',
        DEC2BIN: 'DECABIN',
        DEC2HEX: 'DECAHEX',
        DEC2OCT: 'DECAOCT',
        DECIMAL: 'DECIMAL',
        DEGREES: 'GRAUS',
        DELTA: 'DELTA',
        DOLLARDE: 'MOEDADEC',
        DOLLARFR: 'MOEDAFRA',
        EDATE: 'DATAM',
        EFFECT: 'EFECTIVA',
        EOMONTH: 'FIMMÊS',
        ERF: 'FUNCERRO',
        ERFC: 'FUNCERROCOMPL',
        EVEN: 'PAR',
        EXACT: 'EXACTO',
        EXP: 'EXP',
        FALSE: 'FALSO',
        FIND: 'LOCALIZAR',
        FORMULATEXT: 'FÓRMULA.TEXTO',
        FV: 'VF',
        FVSCHEDULE: 'VFPLANO',
        HEX2BIN: 'HEXABIN',
        HEX2DEC: 'HEXADEC',
        HEX2OCT: 'HEXAOCT',
        HLOOKUP: 'PROCH',
        HOUR: 'HORA',
        HYPERLINK: 'HIPERLIGAÇÃO',
        IF: 'SE',
        IFERROR: 'SE.ERRO',
        IFNA: 'SE.NÃO.DISP',
        IFS: 'SE.S',
        INDEX: 'ÍNDICE',
        INT: 'INT',
        INTERVAL: 'INTERVAL',
        IPMT: 'IPGTO',
        ISBINARY: 'ISBINARY',
        ISBLANK: 'É.CÉL.VAZIA',
        ISERR: 'É.ERROS',
        ISERROR: 'É.ERRO',
        ISEVEN: 'ÉPAR',
        ISFORMULA: 'É.FORMULA',
        ISLOGICAL: 'É.LÓGICO',
        ISNA: 'É.NÃO.DISP',
        ISNONTEXT: 'É.NÃO.TEXTO',
        ISNUMBER: 'É.NÚM',
        ISODD: 'ÉÍMPAR',
        ISOWEEKNUM: 'NÚMSEMANAISO',
        ISPMT: 'É.PGTO',
        ISREF: 'É.REF',
        ISTEXT: 'É.TEXTO',
        LEFT: 'ESQUERDA',
        LEN: 'NÚM.CARACT',
        LN: 'LN',
        LOG10: 'LOG10',
        LOG: 'LOG',
        LOWER: 'MINÚSCULAS',
        MATCH: 'CORRESP',
        MAX: 'MÁXIMO',
        MAXA: 'MÁXIMOA',
        MAXIFS: 'MÁXIMO.SE.S',
        MAXPOOL: 'MAXPOOL',
        MEDIAN: 'MED',
        MEDIANPOOL: 'MEDIANPOOL',
        MID: 'SEG.TEXTO',
        MIN: 'MÍNIMO',
        MINA: 'MÍNIMOA',
        MINIFS: 'MÍNIMO.SE.S',
        MINUTE: 'MINUTO',
        MIRR: 'MTIR',
        MMULT: 'MATRIZ.MULT',
        MOD: 'RESTO',
        MONTH: 'MÊS',
        NA: 'NÃO.DISP',
        NETWORKDAYS: 'DIATRABALHOTOTAL',
        'NETWORKDAYS.INTL': 'DIATRABALHOTOTAL.INTL',
        NOMINAL: 'NOMINAL',
        NOT: 'NÃO',
        NOW: 'AGORA',
        NPER: 'NPER',
        NPV: 'VAL',
        OCT2BIN: 'OCTABIN',
        OCT2DEC: 'OCTADEC',
        OCT2HEX: 'OCTAHEX',
        ODD: 'ÍMPAR',
        OFFSET: 'DESLOCAMENTO',
        OR: 'OU',
        PDURATION: 'PDURAÇÃO',
        PI: 'PI',
        PMT: 'PGTO',
        PRODUCT: 'PRODUTO',
        POWER: 'POTÊNCIA',
        PPMT: 'PPGTO',
        PROPER: 'INICIAL.MAIÚSCULA',
        PV: 'VA',
        RADIANS: 'RADIANOS',
        RAND: 'ALEATÓRIO',
        RATE: 'TAXA',
        REPLACE: 'SUBSTITUIR',
        REPT: 'REPETIR',
        RIGHT: 'DIREITA',
        ROUND: 'ARRED',
        ROUNDDOWN: 'ARRED.PARA.BAIXO',
        ROUNDUP: 'ARRED.PARA.CIMA',
        ROW: 'LIN',
        ROWS: 'LINS',
        RRI: 'DEVOLVERTAXAJUROS',
        SEARCH: 'PROCURAR',
        SEC: 'SEC',
        SECH: 'SECH',
        SECOND: 'SEGUNDO',
        SHEET: 'FOLHA',
        SHEETS: 'FOLHAS',
        SIN: 'SEN',
        SINH: 'SENH',
        SLN: 'AMORT',
        SPLIT: 'SPLIT',
        SQRT: 'RAIZQ',
        STDEVA: 'DESVPADA',
        'STDEV.P': 'DESVPAD.P',
        STDEVPA: 'DESVPADPA',
        'STDEV.S': 'DESVPAD.S',
        SUBSTITUTE: 'SUBST',
        SUBTOTAL: 'SUBTOTAL',
        SUM: 'SOMA',
        SUMIF: 'SOMA.SE',
        SUMIFS: 'SOMA.SE.S',
        SUMPRODUCT: 'SOMARPRODUTO',
        SUMSQ: 'SOMARQUAD',
        SWITCH: '',
        SYD: 'AMORTD',
        T: 'T',
        TAN: 'TAN',
        TANH: 'TANH',
        TBILLEQ: 'OTN',
        TBILLPRICE: 'OTNVALOR',
        TBILLYIELD: 'OTNLUCRO',
        TEXT: 'TEXTO',
        TIME: 'TEMPO',
        TIMEVALUE: 'VALOR.TEMPO',
        TODAY: 'HOJE',
        TRANSPOSE: 'TRANSPOR',
        TRIM: 'COMPACTAR',
        TRUE: 'VERDADEIRO',
        TRUNC: 'TRUNCAR',
        UNICHAR: 'UNICARÁT',
        UNICODE: 'UNICODE',
        UPPER: 'MAIÚSCULAS',
        VARA: 'VARA',
        'VAR.P': 'VAR.P',
        VARPA: 'VARPA',
        'VAR.S': 'VAR.S',
        VLOOKUP: 'PROCV',
        WEEKDAY: 'DIA.SEMANA',
        WEEKNUM: 'NÚMSEMANA',
        WORKDAY: 'DIATRABALHO',
        'WORKDAY.INTL': 'DIATRABALHO.INTL',
        XLOOKUP: 'PROCX',
        XNPV: 'XVAL',
        XOR: 'XOR',
        YEAR: 'ANO',
        YEARFRAC: 'FRAÇÃOANO',
        ROMAN: 'ROMANO',
        ARABIC: 'ÁRABE',
        'HF.ADD': 'HF.ADD',
        'HF.CONCAT': 'HF.CONCAT',
        'HF.DIVIDE': 'HF.DIVIDE',
        'HF.EQ': 'HF.EQ',
        'HF.GT': 'HF.GT',
        'HF.GTE': 'HF.GTE',
        'HF.LT': 'HF.LT',
        'HF.LTE': 'HF.LTE',
        'HF.MINUS': 'HF.MINUS',
        'HF.MULTIPLY': 'HF.MULTIPLY',
        'HF.NE': 'HF.NE',
        'HF.POW': 'HF.POW',
        'HF.UMINUS': 'HF.UMINUS',
        'HF.UNARY_PERCENT': 'HF.UNARY_PERCENT',
        'HF.UPLUS': 'HF.UPLUS',
        VAR: 'VAR',
        VARP: 'VARP',
        STDEV: 'DESVPAD',
        STDEVP: 'DESVPADP',
        FACT: 'FACTORIAL',
        FACTDOUBLE: 'FACTDUPLO',
        COMBIN: 'COMBIN',
        COMBINA: 'COMBIN.R',
        GCD: 'MDC',
        LCM: 'MMC',
        MROUND: 'MARRED',
        MULTINOMIAL: 'POLINOMIAL',
        QUOTIENT: 'QUOCIENTE',
        RANDBETWEEN: 'ALEATÓRIOENTRE',
        SERIESSUM: 'SOMASÉRIE',
        SIGN: 'SINAL',
        SQRTPI: 'RAIZPI',
        SUMX2MY2: 'SOMAX2DY2',
        SUMX2PY2: 'SOMAX2SY2',
        SUMXMY2: 'SOMAXMY2',
        'EXPON.DIST': 'DIST.EXPON',
        EXPONDIST: 'DISTEXPON',
        FISHER: 'FISHER',
        FISHERINV: 'FISHERINV',
        GAMMA: 'GAMA',
        'GAMMA.DIST': 'DIST.GAMA',
        'GAMMA.INV': 'INV.GAMA',
        GAMMADIST: 'DISTGAMA',
        GAMMAINV: 'INVGAMA',
        GAMMALN: 'LNGAMA',
        'GAMMALN.PRECISE': 'LNGAMA.PRECISO',
        GAUSS: 'GAUSS',
        'BETA.DIST': 'DIST.BETA',
        BETADIST: 'DISTBETA',
        'BETA.INV': 'INV.BETA',
        BETAINV: 'BETA.ACUM.INV',
        'BINOM.DIST': 'DISTR.BINOM',
        BINOMDIST: 'DISTRBINOM',
        'BINOM.INV': 'INV.BINOM',
        BESSELI: 'BESSELI',
        BESSELJ: 'BESSELJ',
        BESSELK: 'BESSELK',
        BESSELY: 'BESSELY',
        CHIDIST: 'DIST.CHI',
        CHIINV: 'INV.CHI',
        'CHISQ.DIST': 'DIST.CHIQ',
        'CHISQ.DIST.RT': 'DIST.CHIQ.DIR',
        'CHISQ.INV': 'INV.CHIQ',
        'CHISQ.INV.RT': 'INV.CHIQ.DIR',
        'F.DIST': 'DIST.F',
        'F.DIST.RT': 'DIST.F.DIR',
        'F.INV': 'INV.F',
        'F.INV.RT': 'INV.F.DIR',
        FDIST: 'DISTF',
        FINV: 'INVF',
        WEIBULL: 'WEIBULL',
        'WEIBULL.DIST': 'DIST.WEIBULL',
        POISSON: 'POISSON',
        'POISSON.DIST': 'DIST.POISSON',
        'HYPGEOM.DIST': 'DIST.HIPGEOM',
        HYPGEOMDIST: 'DIST.HIPERGEOM',
        'T.DIST': 'DIST.T',
        'T.DIST.2T': 'DIST.T.2C',
        'T.DIST.RT': 'DIST.T.DIR',
        'T.INV': 'INV.T',
        'T.INV.2T': 'INV.T.2C',
        TDIST: 'DISTT',
        TINV: 'INVT',
        LOGINV: 'INVLOG',
        'LOGNORM.DIST': 'DIST.NORMLOG',
        'LOGNORM.INV': 'INV.NORMALLOG',
        LOGNORMDIST: 'DIST.NORMALLOG',
        'NORM.DIST': 'DIST.NORMAL',
        'NORM.INV': 'INV.NORMAL',
        'NORM.S.DIST': 'DIST.S.NORM',
        'NORM.S.INV': 'INV.S.NORM',
        NORMDIST: 'DIST.NORM',
        NORMINV: 'INV.NORM',
        NORMSDIST: 'DIST.NORMP',
        NORMSINV: 'INV.NORMP',
        PHI: 'PHII',
        'NEGBINOM.DIST': 'DIST.BINOM.NEG',
        NEGBINOMDIST: 'DIST.BIN.NEG',
        COMPLEX: 'COMPLEXO',
        IMABS: 'IMABS',
        IMAGINARY: 'IMAGINÁRIO',
        IMARGUMENT: 'IMARG',
        IMCONJUGATE: 'IMCONJ',
        IMCOS: 'IMCOS',
        IMCOSH: 'IMCOSH',
        IMCOT: 'IMCOT',
        IMCSC: 'IMCSC',
        IMCSCH: 'IMCSCH',
        IMDIV: 'IMDIV',
        IMEXP: 'IMEXP',
        IMLN: 'IMLN',
        IMLOG10: 'IMLOG10',
        IMLOG2: 'IMLOG2',
        IMPOWER: 'IMPOT',
        IMPRODUCT: 'IMPROD',
        IMREAL: 'IMREAL',
        IMSEC: 'IMSEC',
        IMSECH: 'IMSECH',
        IMSIN: 'IMSENO',
        IMSINH: 'IMSENOH',
        IMSQRT: 'IMRAIZ',
        IMSUB: 'IMSUBTR',
        IMSUM: 'IMSOMA',
        IMTAN: 'IMTAN',
        LARGE: 'MAIOR',
        SMALL: 'MENOR',
        AVEDEV: 'DESV.MÉDIO',
        CONFIDENCE: 'INT.CONFIANÇA',
        'CONFIDENCE.NORM': 'INT.CONFIANÇA.NORM',
        'CONFIDENCE.T': 'INT.CONFIANÇA.T',
        DEVSQ: 'DESVQ',
        GEOMEAN: 'MÉDIA.GEOMÉTRICA',
        HARMEAN: 'MÉDIA.HARMÓNICA',
        CRITBINOM: 'CRIT.BINOM',
        PEARSON: 'PEARSON',
        RSQ: 'RQUAD',
        STANDARDIZE: 'NORMALIZAR',
        'Z.TEST': 'TESTE.Z',
        ZTEST: 'TESTEZ',
        'F.TEST': 'TESTE.F',
        FTEST: 'TESTEF',
        STEYX: 'EPADYX',
        SLOPE: 'DECLIVE',
        COVAR: 'COVAR',
        'COVARIANCE.P': 'COVARIÂNCIA.P',
        'COVARIANCE.S': 'COVARIÂNCIA.S',
        'CHISQ.TEST': 'TESTE.CHIQ',
        CHITEST: 'TESTE.CHI',
        'T.TEST': 'TESTE.T',
        TTEST: 'TESTET',
        SKEW: 'DISTORÇÃO',
        'SKEW.P': 'DISTORÇÃO.P',
        WEIBULLDIST: 'WEIBULLDIST',
        VARS: 'VARS',
        TINV2T: 'TINV2T',
        TDISTRT: 'TDISTRT',
        TDIST2T: 'TDIST2T',
        STDEVS: 'STDEVS',
        FINVRT: 'FINVRT',
        FDISTRT: 'FDISTRT',
        CHIDISTRT: 'CHIDISTRT',
        CHIINVRT: 'CHIINVRT',
        COVARIANCEP: 'COVARIANCEP',
        COVARIANCES: 'COVARIANCES',
        LOGNORMINV: 'LOGNORMINV',
        POISSONDIST: 'POISSONDIST',
        SKEWP: 'SKEWP',
        'CEILING.MATH': 'ARRED.EXCESSO.MAT',
        FLOOR: 'ARRED.DEFEITO',
        'FLOOR.MATH': 'ARRED.DEFEITO.MAT',
        'CEILING.PRECISE': 'ARRED.EXCESSO.PRECISO',
        'FLOOR.PRECISE': 'ARRED.DEFEITO.PRECISO',
        'ISO.CEILING': 'ARRED.EXCESSO.ISO',
        N: 'N',
    },
    langCode: 'ptPT',
};
